'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feiseanna = require('../../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _nyiAlert = require('../../../../../nyi-alert');

var _nyiAlert2 = _interopRequireDefault(_nyiAlert);

var _alert = require('../../../../../alert');

var _alert2 = _interopRequireDefault(_alert);

var _trainings = require('ifeis-isomorphic/lib/redux/actions/trainings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeisManagerController = function () {
  function FeisManagerController($mdDialog, feis, metadata, fNyiAlert, $state, isGod, account, msgService, fAlert, $ngRedux, eligibleTrainings) {
    var _this = this;

    _classCallCheck(this, FeisManagerController);

    this._ = { fNyiAlert: fNyiAlert, $state: $state, $mdDialog: $mdDialog, fAlert: fAlert, $ngRedux: $ngRedux };
    this.feis = feis;
    this.isChair = metadata.grants.indexOf('chair') !== -1;
    this.isGod = isGod;
    this.trainings = eligibleTrainings || [];

    // Hide all contents of this page
    // if a user doesn't have at least one manager role
    this.hasAnyRole = isGod || metadata.grants.length > 0;

    var trainingRoles = function trainingRoles() {
      return _this.trainings.length > 0;
    };

    var check = function check() {
      for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
        roles[_key] = arguments[_key];
      }

      function hasRole(role) {
        return metadata.grants.indexOf(role) !== -1;
      }
      return _this.isChair || _this.isGod || roles.some(hasRole);
    };

    var hasNumberAssigned = function hasNumberAssigned() {
      return feis.has_competitor_numbers_assigned ? true : false;
    };

    this.managerTiles = [{
      title: 'Registration',
      background: 'orange',
      icon: 'users',
      enabled: check('registration'),
      state: 'feiseanna.one.admin.registration'
    }, {
      title: 'Status Dashboard',
      background: 'purple',
      icon: 'tachometer',
      enabled: check('chair', 'stage', 'tabulations', 'registration', 'results'),
      state: 'feiseanna.one.admin.dashboard'
    }, {
      title: 'Training Resources',
      background: 'red',
      icon: 'graduation-cap',
      enabled: trainingRoles(),
      state: 'training-resources'
    }, {
      title: 'Stage Stewarding',
      background: 'teal',
      icon: 'bars',
      enabled: check('stage'),
      state: !hasNumberAssigned() ? 'stageStewardingCompetitorsNotAssigned' : 'feiseanna.one.admin.stages'
    }, {
      title: 'Extract scoresheets',
      background: 'orange',
      icon: 'file-image-o',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.textract'
    }, {
      title: 'Tabulations',
      background: 'pink',
      icon: 'keyboard-o',
      enabled: check('tabulations') && hasNumberAssigned(),
      state: 'feiseanna.one.admin.tabulations'
    }, {
      title: 'Printed Placements',
      background: 'green',
      icon: 'print',
      enabled: check('tabulations', 'results'),
      state: 'feiseanna.one.admin.printed-placements'
    }, {
      title: 'Announce Awards',
      background: 'red',
      icon: 'bullhorn',
      enabled: check('tabulations', 'results'),
      state: 'feiseanna.one.admin.announce'
    }, {
      title: 'Awards',
      background: 'blue',
      icon: 'trophy',
      enabled: check('results'),
      state: 'feiseanna.one.admin.awards'
    }, {
      title: 'Scores + Comments',
      background: 'light-green',
      icon: 'star-half-o',
      enabled: check('chair', 'tabulations'),
      state: 'feiseanna.one.admin.scores'
    }, {
      title: 'Close Feis',
      background: 'orange',
      icon: 'flag-checkered',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.finalize'
    }, {
      title: 'Metrics',
      background: 'red',
      icon: 'file-o',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.metrics'
    }];

    this.setupTiles = [{
      title: 'Settings',
      background: 'orange',
      icon: 'cog',
      enabled: check('registration'),
      state: 'feiseanna.one.landing-page'
    }, {
      title: 'Define Your Syllabus',
      background: 'red',
      icon: 'plus-circle',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.syllabus'
    }, {
      title: 'Manage Your Products',
      background: 'blue',
      icon: 'shopping-cart',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.products'
    }, {
      title: 'Publication Settings',
      background: 'light-green',
      icon: 'eye-slash',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.publish'
    }, {
      title: 'Personnel',
      background: 'purple',
      icon: 'key',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.personnel'
    }, {
      title: 'Adjudicators',
      background: 'pink',
      icon: 'gavel',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.adjudicators'
    }, {
      title: 'Schools',
      background: 'cyan',
      icon: 'institution',
      enabled: check('chair', 'registration'),
      state: 'feiseanna.one.admin.schools.all'
    }, { title: 'Schedule',
      background: 'indigo',
      icon: 'calendar',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.schedule'
    }, {
      title: 'Drop Unpaid Registrations',
      background: 'orange',
      icon: 'user-times',
      enabled: check('chair', 'registration'),
      state: 'feiseanna.one.admin.deregister'
    }, {
      title: 'Pre-Feis Printouts',
      background: 'red',
      icon: 'print',
      enabled: true,
      state: 'feiseanna.one.admin.pre-feis-printouts'
    }, {
      title: 'Reports and Downloads',
      background: 'teal',
      icon: 'download',
      enabled: true,
      state: 'feiseanna.one.admin.reports'
    }, {
      title: 'Finance',
      background: 'green',
      icon: 'money',
      enabled: check('chair'),
      state: 'feiseanna.one.admin.finance'
    }];
  }

  _createClass(FeisManagerController, [{
    key: 'goTo',
    value: function goTo($event, state) {
      var _this2 = this;

      if (state === 'training-resources') {
        this._.$mdDialog.show({
          event: $event,
          controller: function controller($scope) {

            $scope.cancel = function () {
              _this2._.$mdDialog.cancel();
            };

            $scope.trainingResources = _this2.trainings;

            $scope.openTrainingUrl = function (url) {
              window.open(url, 'Dynamic Popup', 'height=640' + ', width=640' + 'scrollbars=auto, resizable=no, location=no, status=no');
            };
          },
          template: ['<md-dialog ng-class="class">', '  <form novalidate name="form">', '  <md-content>', '    <md-subheader class="md-sticky-no-effect">Training Resources</md-subheader>', '   <div  style="padding: 23px;" layout="row" layout-wrap ng-repeat="training in trainingResources">', '      <a href="" ng-click="openTrainingUrl(training.url)">{{ training.name }}</a>\n', '  </div>', '  </md-content>', '  <div class="md-actions" layout="row">', '    <md-button type="button" ng-click="cancel()" class="md-primary">Ok</md-button>', '  </div>', '  </form>', '</md-dialog>'].join("\n")
        });
      } else if (state === 'stageStewardingCompetitorsNotAssigned') {
        this._.fAlert($event, 'Oops! Sorry...', 'You cannot access the Stage Steward feature until Competitor Numbers have been assigned. ' + 'Click on Reports, Competitor Cards to assign numbers');
      } else if (state) {
        this._.$state.go(state, this.feis);
      } else {
        this._.fNyiAlert($event);
      }
    }
  }]);

  return FeisManagerController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.manager', ['ui.router', 'ngMaterial', 'ifeis.feiseanna', 'ifeis.nyi', 'ifeis.alert']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.manager', {
    url: '',
    template: require('./tpl.html'),
    controller: 'FeisManagerController',
    controllerAs: 'manager',
    ncyBreadcrumb: {
      label: 'Manage',
      parent: 'feiseanna.one.landing-page'
    },
    resolve: {
      eligibleTrainings: function eligibleTrainings($ngRedux, metadata, isGod) {
        return $ngRedux.dispatch((0, _trainings.getTrainingsByRoles)([].concat(_toConsumableArray(metadata.grants), [isGod && 'god']))).then(function () {
          var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { payload: [] };

          return resp.payload || [];
        });
      }
    }
  });
}).controller('FeisManagerController', FeisManagerController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/manage/index.js
// module id = 547
// module chunks = 0